export default __webpack_public_path__ + "static/media/SFProDisplay-Light.54469e3c.woff2";